const PP_THEME_COLOR = '#FF9800';

const ensureFaviconLink = () => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    return link;
};

const setThemeColor = (color) => {
    let themeMeta = document.querySelector("meta[name='theme-color']");
    if (!themeMeta) {
        themeMeta = document.createElement('meta');
        themeMeta.name = 'theme-color';
        document.head.appendChild(themeMeta);
    }
    themeMeta.setAttribute('content', color);
};

export const applyEnvironmentBranding = (serverURL) => {
    const link = ensureFaviconLink();

    if (serverURL.includes('localhost')) {
        link.href = '/red.ico';
        return;
    }

    if (serverURL.includes('pp')) {
        link.href = '/orange.ico';
        setThemeColor(PP_THEME_COLOR);
        return;
    }

    if (serverURL.includes('-rec.')) {
        link.href = '/red.ico';
    }
};
